module.exports = __webpack_public_path__ + "static/media/contaminacion.3f328ef9.svg";